module.exports = __webpack_public_path__ + "static/media/404-bg.78972237.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/404-bg.png
// module id = 3743
// module chunks = 25